import Table from './Table';
import StyledTableCell from './StyledTableCell';
import StyledTableRow from './StyledTableRow';

export { StyledTableCell };
export { StyledTableRow };

export default Table;
